<template>
  <div>
    <HeaderComponent :pageContent="pageHeader" @change_language="handleHeaderClick"></HeaderComponent>
    <div class="dz-bnr-inr dz-bnr-inr-sm" style="background-image: url(/assets/images/housing/Header.png)">
      <div class="container">
        <div class="dz-bnr-inr-entry">
          <h1 style="color: #0c27bd">{{ pageContent.h1_header }}</h1>
          <!-- <nav aria-label="breadcrumb" class="breadcrumb-row m-t15">
             <ul class="breadcrumb">
               <li class="breadcrumb-item"><a href="index.html">Home</a></li>
               <li class="breadcrumb-item active" aria-current="page">
                 About Us
               </li>
             </ul>
           </nav> -->
        </div>
      </div>
    </div>
    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background-image: url(/assets/images/housing/Body1.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      ">
      <div class="container-fluid">
        <h2 class="text-center text-white" style="font-weight: 400">
          {{ pageContent.title }}
        </h2>
        <p class="text-center text-black" style="font-size: 16px; font-weight: 500">
          {{ pageContent.description }}<br />{{ pageContent.description_br1
          }}<br />{{ pageContent.description_br2 }}
        </p>
        <br />
        <div class="row d-flex align-items-stretch">
          <div class="col-md-6 offset-md-3 d-flex">
            <div class="dz-bnr-inr-entry overlay-white h-100" style="text-align: left">
              <h4 class="text-left text-black" style="text-align: center">
                {{ pageContent.housing_support_title }}
              </h4>
              <p class="text-left mb-2 text-black" style="font-size: 16px; text-align: center">
                {{ pageContent.housing_support_text }}
              </p>
              <br />
              <a href="javascript:void(0);" @click="scrollToSection('mapContainer')">
                <button class="btn btn-primary d-block mx-auto">
                  {{ pageContent.find_school_button }}
                </button>
              </a>
            </div>
          </div>
        </div>
        <br /><br />
        <router-link :to="'/contact-us'">
          <button class="bg-white btn d-block mx-auto text-primary" style="padding: 15px 60px; border-radius: 25px">
            {{ pageContent.get_in_touch_button }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background: #f0f1f5;
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px 0px;
        min-height: 200px;
        height: auto;
      ">
      <div class="container">
        <div class="row bg-white" style="padding: 50px 0px">
          <div class="col-md-3">
            <a href="https://rentinstpete.com/">
              <img src="/assets/images/housing/1.jpeg" class="img-fluid d-block mx-auto" alt="" />
            </a>
          </div>
          <div class="col-md-3" style="text-align: left">
            <p class="text-left text-black">
              Dean & Dewitt Property Management Address: St. Petersburg,
              Florida<br /><br />

              Offers professional property management services to make investing
              in real estate effortless
            </p>
          </div>
          <div class="col-md-3">
            <a href="https://impactrealtytampa.com/" target="_blank">
              <img src="/assets/images/housing/2.png" class="img-fluid d-block mx-auto" alt="" /></a>
          </div>
          <div class="col-md-3" style="text-align: left">
            <p class="text-left text-black">
              Impact Realty Address: Tampa Bay, Florida<br /><br />

              Impact Realty Tampa Bay is a client-focused brokerage specializing
              in buying, selling, and investing in Tampa Bay real estate.
            </p>
          </div>
        </div>
      </div>
      <br /><br />
      <!-- <div class="row" id="map">
        <div class="col-md-7">
          <iframe
            src="https://www.google.com/maps/d/embed?mid=1eqRuqdMuJ5iaYahc5vFwm-xNl5XrnCw&ehbc=2E312F"
            width="100%"
            height="500"
          ></iframe>
        </div>
        <div class="col-md-5">
          <div class="card">
            <div class="card-body" style="text-align: left">
              <h4 class="text-primary">Dean & DeWitt Property Management</h4>
              <p>
                Specializes in managing historic homes, apartment buildings,
                condominiums, and investment properties. Offers professional
                property management services to make investing in real estate
                effortless.
              </p>
              <br />
              <p class="text-primary">Nearby Schools</p>
              <p>
                North Shore Elementary, John Hopkins Middle, St. Petersburg High
              </p>
              <br /><br />
              <h4 class="text-primary">Atrium Property Management</h4>
              <p>
                Provides full, professional leasing and management services,
                handling all aspects of managing rental properties. Offers a
                free rental analysis to optimize rental value.
              </p>
              <br />
              <p class="text-primary">Nearby Schools</p>
              <p>Lakewood Elementary, Bay Point Middle, Lakewood High</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="container-fluid" id="mapContainer">
      <br />
      <div class="row">
        <div class="col-md-12" v-if="isAllLoaded">
          <v-select v-model="selectedSchool" :options="schools.map((s) => s.schoolName)" label="name"
            placeholder="Filter by School" @update:modelValue="filterBySchool" />
          <button class="btn btn-primary mt-2 w-100" @click="resetFilter" v-if="selectedSchool">
            {{ pageContent.reset_button }}
          </button>
        </div>
      </div>
      <br />
    </div>
    <div id="googleMap"></div>

    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background-image: url(/assets/images/housing/Body2.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      ">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="dz-bnr-inr-entry" style="
                background-color: rgba(
                  255,
                  255,
                  255,
                  0.9
                ); /* White with 80% opacity */
                padding: 50px;
                border-radius: 10px;
                color: black;
              ">
              <h1 class="text-left text-primary" style="font-weight: 400">
                {{ pageContent.strong_start_title }}
              </h1>
            </div>
          </div>
        </div>
        <br /><br />
        <router-link :to="'/contact-us'">
          <button class="btn btn-primary d-block mx-auto text-white" style="padding: 15px 60px; border-radius: 25px">
            {{ pageContent.contact_us_button }}
          </button>
        </router-link>
      </div>
    </div>

    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import { Loader } from "@googlemaps/js-api-loader";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { storage, firestore } from "@/firebase";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import globalMixins from "@/plugins/globalMixins";

let currentInfoWindow = null; // Store the currently open InfoWindow
export default {
  name: "HousingAssistance",
  components: {
    HeaderComponent,
    FooterComponent,
    vSelect,
  },
  data() {
    return {
      map: null,
      markers: [],
      schools: [],
      selectedSchool: "",
      loader: null,
      google: null,
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
      isAllLoaded: false,
    };
  },
  async mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) {
      this.language = storedLanguage;
    }
    this.convertLanguage();
    await this.loadMap();
    await this.fetchSchools();
  },
  methods: {
    async loadMap() {
      this.loader = new Loader({
        apiKey: "AIzaSyBi70_IN0DPJiGTL_vbioxhE6iOzXQoXNU",
        version: "weekly", // Keep this for the latest features
        libraries: ["places"],
      });
      const googleMaps = await this.loader.importLibrary("maps"); // ✅ Load Maps
      const placesLibrary = await this.loader.importLibrary("places");
      this.google = window.google; // ✅ Ensure google is globally available

      // Initialize the map using googleMaps.Map (instead of google.maps.Map)

      this.map = new googleMaps.Map(document.getElementById("googleMap"), {
        center: { lat: 27.9483385, lng: -82.45046002 }, // Default center (Manila example)
        zoom: 17,
        mapId: "215ceae1543f2b22",
        mapTypeId: "roadmap",
      });
    },
    formatLabelText(text, maxWordsPerLine = 4) {
      const words = text.split(" ");
      let lines = [];

      for (let i = 0; i < words.length; i += maxWordsPerLine) {
        lines.push(words.slice(i, i + maxWordsPerLine).join(" "));
      }

      return lines.join("<br>"); // Use <br> for multi-line effect
    },
    async nearbySearch(lat, lng) {
      if (!this.map || !this.google) return;

      const { Place, SearchNearbyRankPreference } =
        await this.google.maps.importLibrary("places");
      lat = parseFloat(lat);
      lng = parseFloat(lng);

      let center = { lat: lat, lng: lng };

      const request = {
        fields: ["displayName", "location", "businessStatus"],
        locationRestriction: {
          center,
          radius: 5000, // Increase radius to get more results
        },
        includedPrimaryTypes: ["real_estate_agency"],
        maxResultCount: 20,
        rankPreference: SearchNearbyRankPreference.POPULARITY,
        language: "en-US",
        region: "us",
      };

      // Perform the search
      const { places } = await Place.searchNearby(request);
      if (places.length) {
        const { LatLngBounds } = await this.google.maps.importLibrary("core");
        const bounds = new LatLngBounds();
        const infoWindow = new this.google.maps.InfoWindow();

        places.forEach((place) => {
          const position = place.location;

          if (
            position &&
            typeof position.lat === "function" &&
            typeof position.lng === "function"
          ) {
            const lat = parseFloat(position.lat());
            const lng = parseFloat(position.lng());

            if (!isNaN(lat) && !isNaN(lng)) {
              const customIcon = {
                // url: "https://cdn-icons-png.flaticon.com/512/619/619153.png",
                url: '/assets/images/house.png',
                scaledSize: new this.google.maps.Size(25, 25), // Adjust size
                labelOrigin: new this.google.maps.Point(10, 35), // Move label below
              };

              const marker = new this.google.maps.Marker({
                position: { lat, lng }, // ✅ Now correctly formatted
                map: this.map,
                icon: customIcon,
              });

              const infoWindow = new this.google.maps.InfoWindow({
                content: `<div style="font-size: 10px; color: #333; text-align: center;">
              ${place.displayName}
            </div>`,
                disableAutoPan: true, // Prevent unwanted map movement
                pixelOffset: new this.google.maps.Size(0, 60), // Moves the InfoWindow below the icon
              });

              infoWindow.open(this.map, marker);
              this.google.maps.event.addListener(infoWindow, "domready", () => {
                document
                  .querySelectorAll(".gm-ui-hover-effect")
                  .forEach((el) => {
                    el.style.display = "none"; // Hide close button for all InfoWindows
                  });
              });

              this.google.maps.event.addListener(infoWindow, "domready", () => {
                document.querySelectorAll(".gm-style-iw-ch").forEach((el) => {
                  el.style.display = "none"; // Hide close button for all InfoWindows
                  el.style.display = "0px"; // Hide close button for all InfoWindows
                });
              });

              this.google.maps.event.addListener(infoWindow, "domready", () => {
                document.querySelectorAll(".gm-style-iw-tc").forEach((el) => {
                  el.style.display = "none"; // Hide close button for all InfoWindows
                });
              });

              this.google.maps.event.addListener(infoWindow, "domready", () => {
                document.querySelectorAll(".gm-style-iw-d").forEach((el) => {
                  el.style.overflow = "auto";
                  el.style.minHeight = "20px";
                  el.style.maxHeight = "30px";
                  el.style.maxWidth = "180px";
                  el.style.minWidth = "170px";
                });
              });

              marker.addListener("click", async () => {
                if (currentInfoWindow) {
                  currentInfoWindow.close(); // ✅ Close previous InfoWindow
                }

                const placeDetails = await this.getPlaceDetails(place.id);
                this.showInfoWindow(marker, placeDetails);
              });

              this.markers.push(marker);
              bounds.extend({ lat, lng });
            } else {
              console.warn("Skipping invalid coordinates:", position);
            }

          } else {
            console.warn("Skipping place with missing lat/lng:", place);
          }
        });

        this.map.fitBounds(bounds);
        setTimeout(() => {
          this.map.setZoom(15);
          this.map.setCenter(center);
        }, 300);
      } else {
        // console.log("No results found");
      }
    },
    async getPlaceDetails(placeId) {
      const apiKey = "AIzaSyBi70_IN0DPJiGTL_vbioxhE6iOzXQoXNU"; // Replace with your actual API key
      const fields = "id,displayName,formattedAddress,rating,websiteUri,photos";

      const url = `https://places.googleapis.com/v1/places/${placeId}?fields=${fields}&key=${apiKey}`;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch place details");

        const data = await response.json();
        const photoReference = data.photos?.[0]?.name;
        const photoUrl = photoReference
          ? `https://places.googleapis.com/v1/${photoReference}/media?maxWidthPx=400&key=${apiKey}`
          : null;
        return { ...data, photoUrl };
      } catch (error) {
        console.error("Error fetching place details:", error);
        return null;
      }
    },
    showInfoWindow(marker, place) {
      if (currentInfoWindow) {
        currentInfoWindow.close();
      }
      const infoWindow = new this.google.maps.InfoWindow();

      // Check if a photo URL is available
      const photoUrl = place.photoUrl
        ? `<img src="${place.photoUrl}" alt="Place Image" style="width:100%; max-height:150px; object-fit:cover; border-radius:8px; margin-bottom:8px;">`
        : "";

      // Ensure the title is not empty
      const title = place.displayName?.text || "Unknown Place";

      const content = `
    <div style="max-width:350px;">
      <strong style="font-size:14px; display:block; margin-top:-40px;z-index:-1;position:absolute;">${title}</strong>
      ${photoUrl}
      ${place.formattedAddress || "No address available"}<br>
      Rating: ${place.rating ? place.rating + " ⭐" : "N/A"}<br>
      <a href="${place.websiteUri || "#"
        }" target="_blank" style="color:blue; text-decoration:none;">View on Google Maps</a>
    </div>
  `;

      infoWindow.setContent(content);
      infoWindow.open(this.map, marker);

      currentInfoWindow = infoWindow;

      // Close InfoWindow when clicking outside the marker
      this.map.addListener("click", () => {
        infoWindow.close();
        currentInfoWindow = null;
      });
    },
    async fetchSchools() {
      const schoolsRef = collection(firestore, "schools");
      const q = query(schoolsRef, orderBy("schoolName", "asc")); // 🔹 Order by schoolName ASC

      const querySnapshot = await getDocs(q);
      this.schools = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // Filter schools with valid coordinates
      const schoolWithCoordinates = this.schools.filter(
        (school) => school.lat && school.lng
      );

      // Add markers for valid schools
      var count = 0;
      schoolWithCoordinates.forEach((school) => {
        // console.log("Adding marker for school:", school);
        this.addSchoolMarker(school.lat, school.lng, school);
        // console.log("Marker added for school:", school);
        count++;
      });

      if(count == schoolWithCoordinates.length) {
        this.isAllLoaded = true;
      }
      // console.log("All markers added successfully.");


    },
    resetFilter() {
      this.selectedSchool = ""; // Reset the selected school
      // this.clearMarkers(); // Remove all markers
      this.resetMap();

      const schoolWithCoordinates = this.schools.filter(
        (school) => school.lat && school.lng
      );

      // Add markers for valid schools
      schoolWithCoordinates.forEach((school) => {
        this.addSchoolMarker(school.lat, school.lng, school);
      });
    },
    clearMarkers() {
      // console.log("Clearing markers...");
      if (!this.markers || this.markers.length === 0) {
        console.warn("No markers to clear.");
        return;
      }
      // console.log("Markers to clear:", this.markers);

      this.markers.forEach((marker, index) => {
        if (marker && typeof marker.setMap === "function") {
          // console.log(`Clearing marker at index ${index}:`, marker);
          marker.setMap(null);
        } else {
          console.warn(`Marker at index ${index} is invalid:`, marker);
        }
      });
      // console.log("Markers cleared successfully.");

      this.markers.length = 0; // ✅ Clear the array properly
      this.resetMap();
    },
    goToLink(link) {
      window.open(`https://${link}`, "_blank");
    },
    async filterBySchool() {
      // console.log("Selected school:", this.selectedSchool);
      if (!this.selectedSchool) return;
      // console.log("Filtering by schoolzzz:", this.selectedSchool);
      // this.clearMarkers();
      this.resetMap();
      // console.log("Filtering by schoolxxx:", this.selectedSchool);
      const school = this.schools.find(
        (s) => s.schoolName === this.selectedSchool
      );
      // console.log("Found school:", school);
      this.addSchoolMarker(school.lat, school.lng, school);
      // console.log("Adding marker for school:", school);
      this.nearbySearch(school.lat, school.lng);
      // console.log("Searching nearby places for school:", school);
    },

    async addSchoolMarker(lat, lng, school) {
      if (!this.map) return;

      lat = parseFloat(lat);
      lng = parseFloat(lng);

      if (isNaN(lat) || isNaN(lng)) {
        console.error("Invalid coordinates:", school.schoolName, lat, lng);
        return;
      }

      const customIcon = {
        // url: "https://cdn-icons-png.flaticon.com/512/167/167707.png",
        url: '/assets/images/library.png',

        scaledSize: new this.google.maps.Size(30, 30), // Adjust size
        labelOrigin: new this.google.maps.Point(15, 10), // Move label below
      };

      const marker = new this.google.maps.Marker({
        position: { lat, lng },
        map: this.map,
        icon: customIcon,
        // label: {
        //   background: "#fff",
        //   text: school.schoolName || "Unknown",
        //   color: "#333",
        //   fontWeight: "bold",
        //   fontSize: "12px",
        //   className: "marker-label",
        // },
      });

      const infoWindow = new this.google.maps.InfoWindow({
        content: `<div style="font-size: 14px; color: #333; text-align: center;font-weight:bold;">
              ${school.schoolName}
            </div>`,
        disableAutoPan: true, // Prevent unwanted map movement
      });

      infoWindow.open(this.map, marker);
      this.google.maps.event.addListener(infoWindow, "domready", () => {
        document.querySelectorAll(".gm-ui-hover-effect").forEach((el) => {
          el.style.display = "none"; // Hide close button for all InfoWindows
        });
      });

      this.google.maps.event.addListener(infoWindow, "domready", () => {
        document.querySelectorAll(".gm-style-iw-ch").forEach((el) => {
          el.style.display = "none"; // Hide close button for all InfoWindows
          el.style.display = "0px"; // Hide close button for all InfoWindows
        });
      });

      this.google.maps.event.addListener(infoWindow, "domready", () => {
        document.querySelectorAll(".gm-style-iw-d").forEach((el) => {
          el.style.minHeight = "20px";
          el.style.maxHeight = "30px";
          el.style.maxWidth = "190px";
          el.style.minWidth = "150px";
        });
      });

      marker.addListener("click", () => {
        this.selectedSchool = school.schoolName;
        this.filterBySchool();
      });

      this.markers.push(marker);
    },
    resetMap() {
      // console.log("Resetting map...");
      if (!this.map || !this.google) return;
      // console.log("Map or Google not loaded yet.");
      // Get current center and zoom
      const currentCenter = this.map.getCenter();
      const currentZoom = 13;

      // console.log("Current center:", currentCenter);
      // Destroy and recreate the map
      // console.log("Recreating map...");
      this.map = new this.google.maps.Map(
        document.getElementById("googleMap"),
        {
          center: currentCenter,
          zoom: currentZoom,
          mapId: "215ceae1543f2b22",
          mapTypeId: "roadmap",
        }
      );
      // console.log("Map recreated successfully.");
    },

    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80; // Adjust this value based on your header height
        const elementPosition =
          element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    },
    handleHeaderClick() {
      this.convertLanguage();
    },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) {
        this.language = storedLanguage;
      }

      let lang = this.language;
      if (lang === "us") {
        lang = "en";
      }

      const converted = globalMixins.housing_assistance[lang];

      const pageHeader = globalMixins.pageHeader[lang];

      const pageFooter = globalMixins.pageFooter[lang];

      if (converted) {
        this.pageContent = {
          ...this.pageContent,
          ...converted,
        };

        this.pageHeader = {
          ...this.pageHeader,
          ...pageHeader,
        };
        this.pageFooter = {
          ...this.pageFooter,
          ...pageFooter,
        };
      }
    },
  },
};
</script>


<style scoped>
html {
  scroll-behavior: smooth;
}

.overlay-white {
  background-color: rgba(255, 255, 255, 0.95);
  /* White with 80% opacity */
  padding: 50px;
  border-radius: 10px;
  color: black;
}

ul li {
  list-style: inside;
  font-size: 16px;
}

#googleMap {
  width: 100%;
  height: 800px;
  /* Adjust as needed */
  transition: height 0.3s ease;
}

.marker-label {
  text-shadow: -1px -1px 2px white, 1px -1px 2px white, -1px 1px 2px white,
    1px 1px 2px white;
}
</style>